/* eslint-disable unicorn/filename-case -- kebab-case per docs/conventions/core.md:
   this file exports a function, not a React component. */

// w-10 is the size-8 chevron plus p-1 on each side; the primitive's default p-2 would pad 16px.
export const expandCellClass = (columnId: string) =>
  columnId === 'expand' ? 'w-10 p-1 text-center' : undefined;
